<script setup lang="ts">
import Logo from './Logo.vue';

defineProps<{
  primary?: boolean;
}>();
</script>

<template>
  <div class="d-flex flex-row align-center justify-space-between">
    <logo :primary="primary"></logo>
    <slot></slot>
  </div>
</template>

<style scoped></style>
